// package dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Clipboard from 'clipboard';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
// project dependencies
import { showModal, hideModal } from '../../../actions/ModalActions';
import { fetchGuestList, getGuestGroup, toggleInvited, toggleAllGuestsFacetValue, toggleSortByNameAsc } from '../../../actions/GuestActions'; // eslint-disable-line
import Loader from '../../common/ui/Loader';
import StickyHeaderTable from '../../common/ui/StickyHeaderTable';
import GlobalStats from '../common/GlobalStats';
import Facets from './Facets';
import NoGuests from './NoGuests';
import GuestsTable from './directoryEntities/GuestsTable';
import GuestsHeader from './directoryEntities/GuestsHeader';
import { getIncompleteAddressGuestGroupIds } from './util';


class GuestDirectory extends Component {
  constructor(props) {
    super(props);

    this.checkRow = this.checkRow.bind(this);
    this.checkAllRows = this.checkAllRows.bind(this);
    this.unCheckAllRows = this.unCheckAllRows.bind(this);
    this.resetFacets = this.resetFacets.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.afterExport = this.afterExport.bind(this);
    this.toggleGuestBreakdown = this.toggleGuestBreakdown.bind(this);
    this.showAllGuests = this.showAllGuests.bind(this);

    this.state = {
      checkedRows: [],
      checkedAllRows: false,
      clipboard: undefined,
      // showGuestBreakdown: false,
    };
  }

  componentDidMount() {
    const { getGuestList, getEvents } = this.props;
    getGuestList();
    getEvents();
    this.initializeClipboard();
  }

  componentWillReceiveProps(nextProps) {
    const { filteredIds } = nextProps;
    const { checkedRows } = this.state;

    const nextCheckedRows = _.intersection(checkedRows, filteredIds);
    const nextCheckedAllRows = nextCheckedRows.length !== 0 && nextCheckedRows.length === filteredIds.length;

    this.setState({
      checkedRows: nextCheckedRows,
      checkedAllRows: nextCheckedAllRows,
    });
  }

  componentWillUnmount() {
    const { onUnload } = this.props;
    onUnload();
    this.destroyClipboard();
    this.resetAll();
  }

  checkRow(id, isChecked) {
    const { filteredIds } = this.props;
    const { checkedRows } = this.state;

    if (isChecked) {
      checkedRows.push(id);
    } else {
      _.pull(checkedRows, id);
    }

    this.setState({
      checkedRows,
      checkedAllRows: filteredIds.length === checkedRows.length
    });
  }

  checkAllRows() {
    const { filteredIds } = this.props;
    const checkedAllState = !this.state.checkedAllRows;

    this.setState({
      checkedRows: checkedAllState ? filteredIds.slice() : [],
      checkedAllRows: checkedAllState
    });
  }

  unCheckAllRows() {
    this.setState({
      checkedRows: [],
      checkedAllRows: false
    });
  }

  initializeClipboard() {
    const clipboard = new Clipboard('.collect-address-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      target.setAttribute('data-tooltip', 'Copied!');
      setTimeout(() => {
        target.removeAttribute('data-tooltip');
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  afterExport() {
    const { onConfirmation } = this.props;
    this.exportDropdown.hide();
    onConfirmation('Guest List Exported');
  }

  resetFacets() {
    const { onResetFacets, getGuestList } = this.props;
    onResetFacets();
    getGuestList();
  }

  resetAll() {
    const { onResetFacets, onResetSearchValue, onSelectGuestGroup } = this.props; // eslint-disable-line
    onResetSearchValue();
    // onResetFacets();
    onSelectGuestGroup(null);
  }

  toggleGuestBreakdown() {
    this.setState(state => ({
      showGuestBreakdown: !state.showGuestBreakdown
    }));
  }

  showAllGuests() {
    const { onResetFacets, onResetSearchValue, getGuestList } = this.props;
    onResetSearchValue();
    onResetFacets();
    getGuestList();
  }

  render() {
    const {
      onRequestMissingInfo,
      onGuestMessage,
      onToggleFacet,
      wedding,
      onAddGuestGroup,
      guestGroups,
      onToggleInvited,
      onEditGuestGroup,
      globalStats,
      numGuests,
      numSelectedFacets,
      onDeleteGuestGroups,
      sortByNameAsc,
      onToggleSort,
      selectedFacetValues,
      editGuestModalOpen,
      initialized,
      onEnableGuestListOnboarding,
      onSearchFilterGuestList,
      searchValue,
      filteredIds,
      onSelectGuestGroup,
      selectedGuestGroupId,
    } = this.props;

    const { checkedRows, checkedAllRows } = this.state;

    if (!initialized) {
      return (
        <div className="guestlist-loader">
          <Loader delay />
        </div>
      );
    }

    let definitelyInvitedCount;
    if (_.find(globalStats, { key: 'invited_guests' })) {
      definitelyInvitedCount = _.find(globalStats, { key: 'invited_guests' }).value;
    }
    const formattedGlobalStats = [];
    const formattedGuestAgeStats = [];
    let numGuestsAttending = 0;

    globalStats.forEach((globalStat) => {
      if (globalStat.key === 'addresses_missing' && globalStat.value > 0) {
        formattedGlobalStats.push(Object.assign({}, globalStat, { isLink: true, linkAttrs: { role: 'button', onClick: () => onRequestMissingInfo(getIncompleteAddressGuestGroupIds(guestGroups)) }, tooltip: 'We\'ll help you collect all of these. Click on "Missing Addresses" to begin.' }));
      } else if (globalStat.key === 'guests' && globalStat.value === definitelyInvitedCount) {
        formattedGlobalStats.push(Object.assign({}, globalStat, { hidden: true }));
      } else if (globalStat.key === 'guests' && globalStat.value !== definitelyInvitedCount) {
        formattedGlobalStats.push(Object.assign({}, globalStat, { hidden: false, tooltip: 'Total guests added' }));
      } else if (globalStat.key === 'invited_guests' && globalStat.value > 0) {
        formattedGlobalStats.push(globalStat);
      } else if (globalStat.key === 'adults' || globalStat.key === 'children') {
        numGuestsAttending += globalStat.value;
        formattedGuestAgeStats.push(globalStat);
      } else {
        formattedGlobalStats.push(globalStat);
      }
    });

    return (
      <div>
        <div>
          {numGuests === 0 ? (
            <div>
              <div className="content-top">
                <div className="row">
                  <div className="col-xs-12 navbar-default">
                    <h1 className="page-heading col-xs-12 col-sm-6">All Guests</h1>
                  </div>
                </div>
              </div>
              <NoGuests onAddGuestGroup={onAddGuestGroup} onEnableGuestListOnboarding={onEnableGuestListOnboarding} />
            </div>
          ) : (
            <div>
              <div className="content-top">
                <div className="row">
                  <div className="col-xs-12 navbar-default">
                    <h1 className="page-heading col-xs-12 col-sm-6">All Guests</h1>
                    <div className="nav navbar-nav navbar-right">
                      <ul className="list-inline">
                        <li className="with-tooltip no-tooltip-on-mobile" data-tooltip="Exports guest information to a spreadsheet">
                          <Dropdown ref={(c) => { this.exportDropdown = c; }}>
                            <DropdownTrigger className="btn btn-secondary navbar-btn">Export Guests <i className="zolaicon zolaicon-chevron-down" /></DropdownTrigger>
                            <DropdownContent className="">
                              <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/guest-excel" onClick={this.afterExport}>Export Excel Format</a>
                                </li>
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/all" onClick={this.afterExport}>Export .csv Format</a>
                                </li>
                              </ul>
                            </DropdownContent>
                          </Dropdown>
                        </li>
                        <li>
                          <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Manually enter guests, import an existing spreadsheet, or send a link to guests that collects their information.">
                            <button className="btn btn-primary navbar-btn" onClick={() => onAddGuestGroup()}>+ Add Guests</button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {numGuestsAttending > 0 && (
                    <div>
                      <div className="global-stats-container">
                        <ul className="nav navbar-nav navbar-left" style={{ paddingLeft: '14px' }}>
                          <li className="first-set"><GlobalStats stats={formattedGlobalStats} /></li>
                          <li className="second-set"><GlobalStats stats={formattedGuestAgeStats} /></li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="main-content table guest-table">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="col-xs-12 navbar-default">
                      <div className="nav navbar-nav navbar-left">
                        {checkedRows.length > 0 ? (
                          <ul className="list-inline">
                            <li>
                              <Dropdown ref={(c) => { this.bulkActionsDropdown = c; }}>
                                <DropdownTrigger className="btn-dropdown btn-dropdown-secondary navbar-btn btn btn-boxed">
                                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Perform actions on multiple guests at once.">
                                    <span>Bulk Actions</span>
                                    <i className="zolaicon zolaicon-chevron-down" />
                                  </div>
                                </DropdownTrigger>
                                <DropdownContent>
                                  <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-left">
                                    <li><a role="button" onClick={() => { onRequestMissingInfo(checkedRows); this.bulkActionsDropdown.hide(); }}>Request Missing Info</a></li>
                                    <li><a role="button" onClick={() => { onGuestMessage(checkedRows); this.bulkActionsDropdown.hide(); }}>Send Message</a></li>
                                    <li><a role="button" onClick={() => { onToggleInvited(checkedRows, true); this.bulkActionsDropdown.hide(); }}>Set to &ldquo;Definitely Invited&rdquo;</a></li>
                                    <li><a role="button" onClick={() => { onToggleInvited(checkedRows, false, true); this.bulkActionsDropdown.hide(); }}>Set to &ldquo;Maybe Invited&rdquo;</a></li>
                                    <li><a role="button" onClick={() => { onDeleteGuestGroups(checkedRows); this.bulkActionsDropdown.hide(); }}>Delete</a></li>
                                  </ul>
                                </DropdownContent>
                              </Dropdown>
                            </li>
                            <li>
                              {checkedRows.length} Selected. <a role="button" onClick={this.unCheckAllRows}>Clear Selection</a>
                            </li>
                          </ul>
                        ) : (
                          <ul className="list-inline filter-search-ul-v2">
                            <li>
                              <Dropdown>
                                <DropdownTrigger className="btn-dropdown navbar-btn btn btn-boxed">
                                  {numSelectedFacets ? (
                                    <span>{numSelectedFacets} Filters Selected</span>
                                  ) : (
                                    <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="View specific groups of guests and perform bulk actions."><span>Filter Guests ({numGuests})</span></div>
                                  )}
                                  <i className="zolaicon zolaicon-chevron-down" />
                                </DropdownTrigger>
                                <DropdownContent>
                                  <div className="dropdown-menu dropdown-menu-left">
                                    <Facets selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} onResetFacets={this.resetFacets} />
                                  </div>
                                </DropdownContent>
                              </Dropdown>
                            </li>
                            <li>
                              <div className="has-feedback has-feedback-left">
                                <span className="zolaicon clear-search hidden" />
                                <i className="glyphicon glyphicon-search form-control-feedback hidden-xs hidden-sm" />
                                <input
                                  className="form-control search"
                                  type="search"
                                  placeholder="Search Guest List"
                                  onChange={e => onSearchFilterGuestList(e)}
                                  value={searchValue}
                                />
                              </div>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filteredIds.length === 0 ? (
                    <div className="col-xs-12 text-center">
                      <h3>No Results Found</h3>
                      <p>Try adjusting your search or filter to find what you&apos;re looking for.</p>
                      <button className="btn btn-primary margin-top-2x" onClick={this.showAllGuests}>Show All Guests</button>
                    </div>
                  ) : (
                    <div className="col-xs-12">
                      {filteredIds.length > 0
                        && (
                        <StickyHeaderTable
                          StaticTable={GuestsTable}
                          StickyHeader={GuestsHeader}
                          dataPropName="guestGroups"
                          stickyHeaderCls="table guest-table-v2"
                          checkAllRows={this.checkAllRows}
                          checkedAllRows={checkedAllRows}
                          onToggleSort={onToggleSort}
                          sortByNameAsc={sortByNameAsc}
                          filteredIds={filteredIds}
                          guestGroups={guestGroups}
                          editGuestModalOpen={editGuestModalOpen}
                          selectedGuestGroupId={selectedGuestGroupId}
                          onToggleInvited={onToggleInvited}
                          onEditGuestGroup={onEditGuestGroup}
                          onDeleteGuestGroups={onDeleteGuestGroups}
                          wedding={wedding}
                          onGuestMessage={onGuestMessage}
                          checkedRows={checkedRows}
                          checkRow={this.checkRow}
                          onSelectGuestGroup={onSelectGuestGroup}
                          onRequestMissingInfo={onRequestMissingInfo}
                        />
                        )
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

GuestDirectory.propTypes = {
  getGuestList: PropTypes.func.isRequired,
  onAddGuestGroup: PropTypes.func.isRequired,
  onToggleInvited: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  guestGroups: PropTypes.shape({}),
  globalStats: PropTypes.arrayOf(PropTypes.shape({})),
  numGuests: PropTypes.number,
  numSelectedFacets: PropTypes.number,
  onDeleteGuestGroups: PropTypes.func.isRequired,
  wedding: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  onGuestMessage: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool,
  onToggleSort: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  onUnload: PropTypes.func.isRequired,
  editGuestModalOpen: PropTypes.bool,
  initialized: PropTypes.bool,
  onConfirmation: PropTypes.func,
  onRequestMissingInfo: PropTypes.func,
  onEnableGuestListOnboarding: PropTypes.func,
  getEvents: PropTypes.func,
  onSearchFilterGuestList: PropTypes.func,
  searchValue: PropTypes.string,
  filteredIds: PropTypes.arrayOf(PropTypes.number),
  selectedGuestGroupId: PropTypes.number,
  onResetSearchValue: PropTypes.func,
  onSelectGuestGroup: PropTypes.func,
};

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
});

const mapDispatchToProps = dispatch => ({
  getGuestList: () => dispatch(fetchGuestList()),
  onAddGuestGroup: guestGroupType => dispatch(showModal('ADD_GUEST_GROUP_V2', { callback: () => dispatch(fetchGuestList()), guestGroupType })),
  onEditGuestGroup: (guestGroupId, activeTab) => {
    const callback = () => dispatch(fetchGuestList());
    return dispatch(getGuestGroup(guestGroupId))
      .then(() => dispatch(showModal('EDIT_GUEST_GROUP_WEDDING', { guestGroupId, activeTab, callback })));
  },
  onToggleInvited: (guestGroupIds, isInvited, hasResponses) => {
    if (isInvited) {
      dispatch(toggleInvited(guestGroupIds, isInvited, fetchGuestList));
    } else if (hasResponses) {
      const onConfirmAction = () => dispatch(toggleInvited(guestGroupIds, isInvited, fetchGuestList)).then(() => dispatch(hideModal()));
      dispatch(showModal('UNINVITE_GUEST_CONFIRMATION', { onConfirmAction }, { size: 'md' }));
    } else {
      dispatch(toggleInvited(guestGroupIds, isInvited, fetchGuestList));
    }
  },
  onDeleteGuestGroups: guestGroupIds => dispatch(showModal('DELETE_GUEST_GROUP', { guestGroupIds })),
  onToggleFacet: (facetKey, facetValue) => dispatch(toggleAllGuestsFacetValue(facetKey, facetValue)),
  onToggleSort: () => {
    dispatch(toggleSortByNameAsc());
    dispatch(fetchGuestList());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestDirectory);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/Directory.jsx